// This icon file is generated automatically.
var DrrpTagcntIconOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 40 40", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M37 8H20.4a.9.9 0 01-.7-.3l-3.4-3.4a.9.9 0 00-.7-.3H3c-.6 0-1 .4-1 1v30c0 .6.4 1 1 1h34c.6 0 1-.4 1-1V9c0-.6-.4-1-1-1zm-1 26H4V6h11.2l3.1 3.1c.6.6 1.3.9 2.1.9H36v24zM18.1 14.4l8.5 8.5-5.7 5.7-8.5-8.5.5-5.2 5.2-.5m.3-2l-6.5.6c-.5 0-.9.4-.9.9l-.6 6.5c0 .3.1.6.3.8l9.6 9.6c.2.2.5.3.7.3.2 0 .5-.1.7-.3l7.1-7.1c.4-.4.4-1 0-1.4l-9.6-9.6c-.2-.2-.5-.3-.8-.3zM15 18a1 1 0 102 0 1 1 0 00-2 0z", "fill-rule": "nonzero" } }] }, "name": "drrp-tagcnt-icon", "theme": "outlined" };
export default DrrpTagcntIconOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/DrrpTagcntIconOutlined.js
// module id = 2578
// module chunks = 0